<template>
  <div class="panel shadow" v-show="allItemsCount">
    <h3 class="panel-title" :style="headerExtraStyle">{{ title }}</h3>
    <div class="panel-content">
      <slot></slot>

      <div class="buttons">
        <div v-for="source in allSources" class="button-group">
          <div v-for="target in targets" v-if="target" class="button-group">
            <a class="button" @click="transfer(target, source.characterId)"
               v-show="itemsToTransfer(target.characterId, source.characterId).length">
              <i class="material-icons">play_arrow</i><span class=""> {{ source.className }} ➡ {{ target.className
              }}</span>
              <span class="number">({{ itemsToTransfer(target.characterId, source.characterId).length }})</span>
            </a>
            <a class="button info" v-show="itemsToTransfer(target.characterId, source.characterId).length"
               @click.stop="preview(target.characterId, source.characterId)">
              <i class="material-icons">details</i>
            </a>
          </div>
        </div>
      </div>
      <div class="preview" v-if="previewItems.length">
        <i class="material-icons close" @click="previewItems=[]">close</i>
        <item v-for="item in previewItems" :item="item" :key="title+item.key" :character="currentCharacter"></item>
      </div>
    </div>
  </div>
</template>

<script>
  import Item from './Item.vue'

  export default {
    name: 'TransferPanel',
    props: ['title', 'subtitle', 'items', 'targets', 'sources', 'color'],
    data () {
      return {
        previewItems: [],
        currentCharacter: null
      }
    },
    computed: {
      headerExtraStyle () {
        if (this.color) {
          return {'backgroundColor': this.color}
        }
        return {}
      },
      allSources () {
        return this.sources || [{'className': 'Transfer'}]
      },
      allItemsCount () {
        return this.targets
          .filter(target => target)
          .map(target => target.characterId)
          .map(characterId => this.itemsToTransfer(characterId).length)
          .reduce((acc, i) => acc + i, 0)
      }
    },
    methods: {
      itemsToTransfer (characterId, sourceId) {
        const items = this.items.filter(item => item.canTransferTo(characterId))
        if (sourceId) {
          return items.filter(item => item.characterHash === sourceId)
        }
        return items
      },
      preview (characterId, sourceId) {
        this.currentCharacter = characterId
        this.previewItems = this.itemsToTransfer(characterId, sourceId)
        console.log('pi', this.previewItems)
      },
      transfer (target, sourceId) {
        return Promise.all(this.itemsToTransfer(target.characterId, sourceId).map(item => item.transfer(target)))
      }
    },
    components: {Item}
  }
</script>

<style lang="scss">
  @import "../styles/settings";
  @import "../styles/panel";

</style>




// WEBPACK FOOTER //
// TransferPanel.vue?7a274836